import React from 'react';

const Main = (props) => {
  const { main } = props
    return (
    <div>
      <div ref={main} className='main-container'>
        <div className='background-img'>
          <div className="cover"></div>
        </div>
        <p className='intro'>
        Passionate web developer. Native New Yorker. Former United States Marine. 
        </p>
      </div>
    </div>
  );
};

export default Main;
